module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "calibre8",
    attrs: {
      "id": "pgepubid00017"
    }
  }, [_vm._v("Full-page Illustrations")]), _vm._v(" "), _c('table', {
    staticClass: "calibre14",
    attrs: {
      "summary": "Illustrations"
    }
  }, [_c('tbody', {
    staticClass: "calibre3"
  }, [_c('tr', {
    staticClass: "calibre4"
  }, [_c('td', {
    staticClass: "calibre6"
  }, [_c('a', {
    staticClass: "pcalibre pcalibre2 pcalibre1",
    attrs: {
      "href": "#/Text/Section0002#image_01"
    }
  }, [_vm._v("PRINCESS LABAM")])]), _vm._v(" "), _c('td', {
    staticClass: "calibre6"
  }), _vm._v(" "), _c('td', {
    staticClass: "calibre6"
  }), _vm._v(" "), _c('td', {
    staticClass: "calibre6"
  }), _vm._v(" "), _c('td', {
    staticClass: "calibre6"
  }), _vm._v(" "), _c('td', {
    staticClass: "calibre6"
  }), _vm._v(" "), _c('td', {
    staticClass: "c4"
  }, [_c('a', {
    staticClass: "pcalibre pcalibre2 pcalibre1",
    attrs: {
      "href": "#/Text/Section0002#image_01"
    }
  }, [_vm._v("Frontispiece")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre4"
  }, [_c('td', {
    staticClass: "calibre6"
  }, [_c('a', {
    staticClass: "pcalibre pcalibre2 pcalibre1",
    attrs: {
      "href": "#/Text/Section0004#image_02"
    }
  }, [_vm._v("THE LION AND THE CRANE")])]), _vm._v(" "), _c('td', {
    staticClass: "calibre6"
  }), _vm._v(" "), _c('td', {
    staticClass: "c4"
  }, [_vm._v("To face page")]), _vm._v(" "), _c('td', {
    staticClass: "calibre6"
  }), _vm._v(" "), _c('td', {
    staticClass: "calibre6"
  }), _vm._v(" "), _c('td', {
    staticClass: "calibre6"
  }), _vm._v(" "), _c('td', {
    staticClass: "tocpg"
  }, [_c('a', {
    staticClass: "pcalibre pcalibre2 pcalibre1",
    attrs: {
      "href": "#/Text/Section0004#Page_2"
    }
  }, [_vm._v("2")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre4"
  }, [_c('td', {
    staticClass: "calibre6"
  }, [_c('a', {
    staticClass: "pcalibre pcalibre2 pcalibre1",
    attrs: {
      "href": "#/Text/Section0007#image_03"
    }
  }, [_vm._v("PUNCHKIN")])]), _vm._v(" "), _c('td', {
    staticClass: "calibre6"
  }), _vm._v(" "), _c('td', {
    staticClass: "calibre15"
  }, [_vm._v("\"")]), _vm._v(" "), _c('td', {
    staticClass: "calibre15"
  }), _vm._v(" "), _c('td', {
    staticClass: "calibre6"
  }), _vm._v(" "), _c('td', {
    staticClass: "calibre6"
  }), _vm._v(" "), _c('td', {
    staticClass: "tocpg"
  }, [_c('a', {
    staticClass: "pcalibre pcalibre2 pcalibre1",
    attrs: {
      "href": "#/Text/Section0007#Page_36"
    }
  }, [_vm._v("36")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre4"
  }, [_c('td', {
    staticClass: "calibre6"
  }, [_c('span', {
    staticClass: "pcalibre pcalibre2 pcalibre1",
    attrs: {
      "href": "#/Text/Section0011#image_04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("LOVING LAILI")])]), _vm._v(" "), _c('td', {
    staticClass: "calibre6"
  }), _vm._v(" "), _c('td', {
    staticClass: "calibre15"
  }, [_vm._v("\"")]), _vm._v(" "), _c('td', {
    staticClass: "calibre15"
  }), _vm._v(" "), _c('td', {
    staticClass: "calibre6"
  }), _vm._v(" "), _c('td', {
    staticClass: "calibre6"
  }), _vm._v(" "), _c('td', {
    staticClass: "tocpg"
  }, [_c('span', {
    staticClass: "pcalibre pcalibre2 pcalibre1",
    attrs: {
      "href": "#/Text/Section0011#Page_64",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("64")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre4"
  }, [_c('td', {
    staticClass: "calibre6"
  }, [_c('span', {
    staticClass: "pcalibre pcalibre2 pcalibre1",
    attrs: {
      "href": "#/Text/Section0015#image_05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THE CHARMED RING")])]), _vm._v(" "), _c('td', {
    staticClass: "calibre6"
  }), _vm._v(" "), _c('td', {
    staticClass: "calibre15"
  }, [_vm._v("\"")]), _vm._v(" "), _c('td', {
    staticClass: "calibre15"
  }), _vm._v(" "), _c('td', {
    staticClass: "calibre6"
  }), _vm._v(" "), _c('td', {
    staticClass: "calibre6"
  }), _vm._v(" "), _c('td', {
    staticClass: "tocpg"
  }, [_c('span', {
    staticClass: "pcalibre pcalibre2 pcalibre1",
    attrs: {
      "href": "#/Text/Section0015#Page_96",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("96")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre4"
  }, [_c('td', {
    staticClass: "calibre6"
  }, [_c('span', {
    staticClass: "pcalibre pcalibre2 pcalibre1",
    attrs: {
      "href": "#/Text/Section0019#image_06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THE SON OF SEVEN QUEENS")])]), _vm._v(" "), _c('td', {
    staticClass: "calibre6"
  }), _vm._v(" "), _c('td', {
    staticClass: "calibre15"
  }, [_vm._v("\"")]), _vm._v(" "), _c('td', {
    staticClass: "calibre15"
  }), _vm._v(" "), _c('td', {
    staticClass: "calibre6"
  }), _vm._v(" "), _c('td', {
    staticClass: "calibre6"
  }), _vm._v(" "), _c('td', {
    staticClass: "tocpg"
  }, [_c('span', {
    staticClass: "pcalibre pcalibre2 pcalibre1",
    attrs: {
      "href": "#/Text/Section0019#Page_120",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("120")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre4"
  }, [_c('td', {
    staticClass: "calibre6"
  }, [_c('span', {
    staticClass: "pcalibre pcalibre2 pcalibre1",
    attrs: {
      "href": "#/Text/Section0022#image_07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("RAJA RASALU")])]), _vm._v(" "), _c('td', {
    staticClass: "calibre6"
  }), _vm._v(" "), _c('td', {
    staticClass: "calibre15"
  }, [_vm._v("\"")]), _vm._v(" "), _c('td', {
    staticClass: "calibre15"
  }), _vm._v(" "), _c('td', {
    staticClass: "calibre6"
  }), _vm._v(" "), _c('td', {
    staticClass: "calibre6"
  }), _vm._v(" "), _c('td', {
    staticClass: "tocpg"
  }, [_c('span', {
    staticClass: "pcalibre pcalibre2 pcalibre1",
    attrs: {
      "href": "#/Text/Section0022#Page_146",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("146")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre4"
  }, [_c('td', {
    staticClass: "calibre6"
  }, [_c('span', {
    staticClass: "pcalibre pcalibre2 pcalibre1",
    attrs: {
      "href": "#/Text/Section0025#image_08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("BOY WITH MOON ON FOREHEAD")])]), _vm._v(" "), _c('td', {
    staticClass: "calibre6"
  }), _vm._v(" "), _c('td', {
    staticClass: "calibre15"
  }, [_vm._v("\"")]), _vm._v(" "), _c('td', {
    staticClass: "calibre15"
  }), _vm._v(" "), _c('td', {
    staticClass: "calibre6"
  }), _vm._v(" "), _c('td', {
    staticClass: "calibre6"
  }), _vm._v(" "), _c('td', {
    staticClass: "tocpg"
  }, [_c('span', {
    staticClass: "pcalibre pcalibre2 pcalibre1",
    attrs: {
      "href": "#/Text/Section0025#Page_165",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("165")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre4"
  }, [_c('td', {
    staticClass: "calibre6"
  }, [_c('span', {
    staticClass: "pcalibre pcalibre2 pcalibre1",
    attrs: {
      "href": "#/Text/Section0028#image_09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("DEMON WITH MATTED HAIR")])]), _vm._v(" "), _c('td', {
    staticClass: "calibre6"
  }), _vm._v(" "), _c('td', {
    staticClass: "calibre15"
  }, [_vm._v("\"")]), _vm._v(" "), _c('td', {
    staticClass: "calibre15"
  }), _vm._v(" "), _c('td', {
    staticClass: "calibre6"
  }), _vm._v(" "), _c('td', {
    staticClass: "calibre6"
  }), _vm._v(" "), _c('td', {
    staticClass: "tocpg"
  }, [_c('span', {
    staticClass: "pcalibre pcalibre2 pcalibre1",
    attrs: {
      "href": "#/Text/Section0028#Page_196",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("196")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "blockquot"
  }, [_c('p', {
    staticClass: "center1"
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('a', {
    staticClass: "pcalibre pcalibre2 pcalibre1",
    attrs: {
      "id": "Page_1",
      "title": "[1]"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a61bab10","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Section0003.vue
// module id = 63
// module chunks = 0